import * as React from 'react'
import { Navigate } from 'react-router-dom'
import StateContext from 'src/context/UserProvider';
import { ConditionalRouteProps } from 'src/models/types/ConditionalRouteProps';

/**
 * @function ConditionalRoute
 * @description Valida si el usuario posee la función o no para poder ver la ruta.
 * @param {string | number} idFunction Identificación de función que debe ver si existe.
 * @param {string} redirectTo Ruta a la cual se redirije si falla.
 * @param {React.ReactNode} children Componente al cual se va a dirijir si es válido.
 * @returns {React.JSX.Element}
 */
export default function ConditionalRoute({
  idFunction,
  redirectTo,
  children,
}: ConditionalRouteProps): React.JSX.Element {
  const { existFunction } = StateContext();
  return existFunction(idFunction) ? <>{children}</> : <Navigate to={redirectTo} replace />;
}
